module.exports = __webpack_public_path__ + "media/sub3-6-3.868331bc.mp4";